import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEuroBlue = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M12.917 15.417a5.4 5.4 0 0 1-4.8-2.917h4.8l.833-1.667H7.567A5.5 5.5 0 0 1 7.5 10q.002-.422.067-.833h5.35L13.75 7.5H8.117a5.41 5.41 0 0 1 8.325-1.608l1.475-1.475a7.46 7.46 0 0 0-5-1.917c-3.267 0-6.034 2.092-7.067 5H2.917l-.834 1.667h3.384a7 7 0 0 0 0 1.666h-2.55L2.083 12.5H5.85c1.033 2.908 3.8 5 7.067 5a7.45 7.45 0 0 0 5-1.917l-1.484-1.475a5.34 5.34 0 0 1-3.516 1.309"
	})]
});
const ForwardRef = forwardRef(SvgEuroBlue);
export { ForwardRef as ReactComponent };
